import jamespot, { getExtensionFromName, jFileLittle, resolveFilePath } from 'jamespot-user-api';
import React, { useCallback } from 'react';
import { JRCFileViewer } from '../JRCFileViewer/JRCFileViewer';

import { JRCFileViewerOpenWithOptionsType } from '../JRCFileViewer/types';
import { useIntl } from 'react-intl';
import { JRCWidgetAttachment } from 'components/Widgets/JRCWidgetAttachment/JRCWidgetAttachment';

const ONLY_OFFICE_EXTENSION = [
    'doc',
    'docm',
    'docx',
    'docxf',
    'dot',
    'dotm',
    'dotx',
    'epub',
    'fodt',
    'fb2',
    'htm',
    'mht',
    'odt',
    'oform',
    'ott',
    'oxps',
    'rtf',
    'txt',
    'djvu',
    'xml',
    'xps',
    'csv',
    'fods',
    'ods',
    'ots',
    'xls',
    'xlsb',
    'xlsm',
    'xlsx',
    'xlt',
    'xltm',
    'xltx',
    'fodp',
    'odp',
    'otp',
    'pot',
    'potm',
    'potx',
    'pps',
    'ppsm',
    'ppsx',
    'ppt',
    'pptm',
    'pptx',
    'pdf',
];

export type JRCAttachmentsProps = {
    files: jFileLittle[];
    getAccessHash?: (fileId: number) => Promise<string>;
    onError?: (message?: string) => void;
    onDelete?: (id: number) => Promise<void>;
    mode?: 'view' | 'edit';
};

export const JRCAttachments = ({ files, getAccessHash, onError, onDelete, mode = 'view' }: JRCAttachmentsProps) => {
    const intl = useIntl();

    const fetchHash = useCallback(
        async (fileId: number) => {
            if (getAccessHash) return getAccessHash;
            const response = await jamespot.object.getAccessHash(`fileArticle/${fileId}`);

            return response.result;
        },
        [getAccessHash],
    );

    const onClickOnlyOffice = useCallback(
        (file: jFileLittle | undefined) => {
            if (!file) {
                return;
            }
            fetchHash(file.id)
                .then((hash) => {
                    window.open(`/ng/rr/file/${file.id}/${hash}`, '_blank');
                })
                .catch(() => {
                    if (onError) {
                        onError(intl.formatMessage({ id: 'WIDGET_Open_Failed' }));
                    }
                });
        },
        [fetchHash, intl, onError],
    );

    const optionOnlyOffice = [
        {
            label: intl.formatMessage({ id: 'WIDGET_Open_With_Wedoc' }),
            onClick: onClickOnlyOffice,
        },
    ];

    const openWithOptions: JRCFileViewerOpenWithOptionsType = [
        {
            condition: (file) => ONLY_OFFICE_EXTENSION.includes(getExtensionFromName(file.title)),
            options: optionOnlyOffice,
        },
    ];

    return (
        <JRCFileViewer files={files} openWithOptions={openWithOptions}>
            {(open) => {
                return (
                    <JRCWidgetAttachment
                        files={files.map((f) => ({
                            id: f.id,
                            mimetype: f.mimetype,
                            title: f.title,
                            uri: resolveFilePath(f),
                            size: f.size,
                        }))}
                        onClick={(idFile) => open(idFile)}
                        onDelete={onDelete}
                        onError={onError}
                        mode={mode}
                    />
                );
            }}
        </JRCFileViewer>
    );
};
